import React from 'react';
import { StarIcon } from 'lucide-react';
export function TrustpilotRating() {
  const filledStars = 4;
  const partialStar = 0.5;
  const totalStars = 5;
  return <div className="w-full max-w-4xl mx-auto px-6 py-4 flex items-center justify-center gap-3 flex-wrap" data-id="element-112">
      <span className="text-lg md:text-xl font-semibold text-gray-800" data-id="element-113">
        Excellent
      </span>

      <div className="flex gap-0.5" aria-label={`Rated ${filledStars + partialStar} out of ${totalStars} stars`} data-id="element-114">
        {Array.from({
        length: totalStars
      }).map((_, i) => {
        const isFull = i < filledStars;
        const isPartial = i === filledStars;
        return <div key={i} className="relative w-7 h-7 md:w-8 md:h-8 bg-[#00B67A] flex items-center justify-center" data-id="element-115">
              {isPartial && <div className="absolute inset-0 bg-gray-300" style={{
            clipPath: 'inset(0 0 0 50%)'
          }} data-id="element-116" />}
              <StarIcon className="relative w-5 h-5 md:w-6 md:h-6 text-white" fill="white" strokeWidth={0} data-id="element-117" />
            </div>;
      })}
      </div>

      <div className="flex items-center gap-1" data-id="element-118">
        <StarIcon className="w-5 h-5 text-[#00B67A]" fill="#00B67A" strokeWidth={0} data-id="element-119" />
        <span className="text-lg md:text-xl font-semibold text-gray-800" data-id="element-120">
          Trustpilot
        </span>
      </div>
    </div>;
}